// Duits (de-DE), kioskBoard (het woonkamerbord): zelfde vorm als kioskBoard.nl.ts. Korte,
// eenvoudige woorden voor kinderen (tegels). Wat ontbreekt valt terug op het Nederlands.
export const kioskBoardDe = {
    weekToggle: 'Woche',
    weekTitle: 'Woche {week}',
    weekTitleToday: 'Heute - Woche {week}',
    backToToday: 'Heute',
    menu: 'Mehr',
    menuMake: 'Erstellen',
    menuHome: 'Zuhause',
    menuBoard: 'Tafel',
    boardRefreshing: 'Aktualisieren…',
    boardLoading: 'Laden…',
    boardRefreshFailed: 'Aktualisieren hat nicht geklappt: keine Verbindung. Die Tafel zeigt die zuletzt bekannten Daten.',
    pageOf: 'Seite {n} von {total}',
    prevWeek: 'Letzte Woche',
    nextWeek: 'Nächste Woche',
    weekEmpty: 'Diese Woche ist noch leer',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'Tag',
    modeWeek: 'Woche',
    agendaMode: 'Ansicht',
    prevDay: 'Vorheriger Tag',
    nextDay: 'Nächster Tag',
    filterPeople: 'Anzeigen für',
    noEventsWeek: 'Keine Termine diese Woche',
    noEventsDay: 'Keine Termine an diesem Tag',
    noEventsFor: 'Nichts geplant für {names}',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'Monat',
    prevMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    noEventsMonth: 'Keine Termine in diesem Monat',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'Fahrzeit',
    rideBring: 'Bringen',
    rideFetch: 'Abholen',
    rideOnTheWay: 'Unterwegs',
    rideBack: 'Zurück',
    moreItems: '+{count}',
    laterAt: 'Gleich · {time}',
    nowUntil: 'Jetzt · bis {time}',
    scrollMore: 'Mehr Termine',
    tasksMore: 'Mehr Aufgaben',
    tasksLess: 'Nach oben',
    departClose: 'Hinweis schließen',
    departWho: '{names}: {title}, los um {time}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} bringt',
    ridePickup: '{name} holt ab',
    and: 'und',
    travel: '{minutes} Min. unterwegs',
    leaveAt: 'los um {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'zu Hause um {time}',
    conflict: 'Gleichzeitig mit etwas anderem',
    continues: 'Geht weiter',
    tomorrowFirst: 'Morgen {time}: {title}',
    waitingApproval: 'Wartet auf Mama/Papa',
    klaarApproval: 'Mama oder Papa schauen es sich noch an.',
    doneBy: '{name} war zuerst',
    claimedBy: '{name} macht das',
    tryAgain: 'Noch mal?',
    notSaved: 'Das hat nicht geklappt',
    cloudPending: 'Wird gespeichert…',
    memberRail: 'Familie',
    pointsReserved: '{count} reserviert',
    rewardsTile: 'Belohnungen',
    rewardsOf: 'Belohnungen von {name}',
    goal: 'Ziel: {name}',
    goalProgress: '{value} von {max}',
    goalHint: 'Wählt zusammen ein Sparziel',
    rewardCanGet: 'Reicht!',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'Verfügbar',
    rewardMissing: 'Noch {count}',
    rewardWaiting: 'Wartet auf Mama/Papa',
    rewardBusy: 'Erst die andere',
    rewardLimit: 'Morgen wieder',
    rewardSoldOut: 'Alle weg',
    rewardCancel: 'Abbrechen',
    whoAreYou: 'Wer bist du?',
    requestQuestion: '{reward} eintauschen?',
    cancelQuestion: '{reward} doch nicht?',
    keepIt: 'Nein, behalten',
    cancelYes: 'Ja, doch nicht',
    notYou: 'Nicht du?',
    areYou: 'Bist du {name}?',
    yesMe: 'Ja, das bin ich',
    notMe: 'Nein',
    notYours: 'Das gehört {name}',
    notYoursBody: 'Schau, hier ist deine Liste.',
    closeRewards: 'Zurück zu Heute',
    detailClose: 'Schließen',
    detailEdit: 'Bearbeiten',
    sleepWell: 'Schlaf gut',
    tomorrowAt: 'Morgen um {time}: {title}',
    calmDown: 'Nicht so schnell…',
    upcoming: 'Demnächst',
    tomorrowEmpty: 'Noch nichts geplant',
    inDays: { one: 'in {count} Tag', other: 'in {count} Tagen' },
};
//# sourceMappingURL=kioskBoard.de.js.map